// import React, { useEffect } from "react";
// import { Fragment } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import Header from "../../Shear/Header/Header";
// import Footer from "../../Shear/Footer/Footer";
// import Head from "../../../layout/Head";
// import ScrollToTop from "../../Shear/ScrollToTop";
// import { useCreateUserWithEmailAndPassword, useUpdateProfile } from "react-firebase-hooks/auth";
// import auth from "../../../FirebaseInit/FirebaseInit";
// import useToken from "../../../Hooks/useToken";
// import { toast } from "react-toastify";

// const SignUp = () => {

//   // start
//   let navigate = useNavigate();
//   /** Create User With email password start here **/
//   const [createUserWithEmailAndPassword, user, loading, error] =
//     useCreateUserWithEmailAndPassword(auth, { sendEmailVerification: true });

//   /**  User profile update start here **/
//   const [updateProfile, updating, updateError] = useUpdateProfile(auth);
//   const [token] = useToken(user);
//   useEffect(() => {
//     if (token) {
//       navigate("/");
//     }
//   }, [token, user, navigate]);

//   /** Sign Up error code start **/
//   let errorMessage = "";
//   if (error || updateError ) {
//     errorMessage =
//       error?.message ||
//       updateError?.message ;
//       toast.error(errorMessage)

//   }

//   const onSubmitHandler = async (e) => {
//     e.preventDefault();
//     const data = new FormData(e.target);
//     const result = Object.fromEntries(data.entries());
//     if(result.password === result.confirmPassword){
//    await createUserWithEmailAndPassword(result.email, result.password);
//     await updateProfile({ displayName: result.name });
//     toast("Successfully signed up! Check email!");
//     }else{
//       toast.error("Sorry, your password was not match")
//     }

//   };

//   return (
//     <Fragment>
//       <Head
//         Title="Sign Up"
//         href="/register"
//         description="IT Services Providers are companies that offer a range of IT services and solutions to help organizations manage their technology infrastructure | Register Pages"
//       />
//       <Header title="Sign Up" />
//       <section className="bg-gray-50 dark:bg-gray-900 py-10">
//         <div className="flex flex-col items-center justify-center px-6 mx-auto  py-20">
//           <div className="w-full bg-white rounded-lg shadow dark:border max-md:mt-0 max-sm:max-w-md max-xl:p-0 border border-[#f7f7f7]">
//             <div className="p-6 space-y-4 max-md:space-y-6 max-sm:p-8">
//               <h2 className="text-xl text-linear-gradient font-bold leading-tight tracking-tight text-gray-900 max-md:text-2xl dark:text-white">
//                 Sign Up
//               </h2>
//               <form
//                 onSubmit={onSubmitHandler}
//                 className="space-y-4 max-md:space-y-6"
//               >
//                 <div>
//                   <label
//                     htmlFor="name"
//                     className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
//                   >
//                     Your Name
//                   </label>
//                   <input
//                     type="text"
//                     name="name"
//                     id="name"
//                     className="bg-gray-50 border border-[#d3d3d3] text-gray-900 max-sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
//                     placeholder="Enter Your Name"
//                     required
//                   />
//                 </div>

//                 <div>
//                   <label
//                     htmlFor="email"
//                     className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
//                   >
//                     Your email
//                   </label>
//                   <input
//                     type="email"
//                     name="email"
//                     id="email"
//                     className="bg-gray-50 border border-[#d3d3d3] text-gray-900 max-sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
//                     placeholder="name@company.com"
//                     required=""
//                   />
//                 </div>

//                 <div>
//                   <label
//                     htmlFor="password"
//                     className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
//                   >
//                     Password
//                   </label>
//                   <input
//                     type="password"
//                     name="password"
//                     id="password"
//                     placeholder="••••••••"
//                     className="bg-gray-50 border border-[#d3d3d3] text-gray-900 max-sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
//                     required=""
//                   />
//                 </div>
//                 <div>
//                   <label
//                     htmlFor="confirm-password"
//                     className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
//                   >
//                     Confirm password
//                   </label>
//                   <input
//                     type="confirm-password"
//                     name="confirmPassword"
//                     id="confirm-password"
//                     placeholder="••••••••"
//                     className="bg-gray-50 border border-[#d3d3d3] text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
//                     required
//                   />
//                 </div>
//                 {loading ? (
//                   <button
//                     type="button"
//                     style={{ boxShadow: "none" }}
//                     disabled
//                     className="inline-flex w-full text-[#fff]  px-2 py-5   bg-linear-gradient cursor-pointer select-none appearance-none items-center justify-center space-x-2 rounded-lg border border-blue-700 bg-blue-700 text-sm font-medium text-white transition "
//                   >
//                     <svg className="h-4 w-4 animate-spin" viewBox="3 3 18 18">
//                       <path
//                         className="fill-[#fff]"
//                         d="M12 5C8.13401 5 5 8.13401 5 12c0 3.866 3.13401 7 7 7 3.866.0 7-3.134 7-7 0-3.86599-3.134-7-7-7zM3 12c0-4.97056 4.02944-9 9-9 4.9706.0 9 4.02944 9 9 0 4.9706-4.0294 9-9 9-4.97056.0-9-4.0294-9-9z"
//                       ></path>
//                       <path
//                         className="fill-[#fff]"
//                         d="M16.9497 7.05015c-2.7336-2.73367-7.16578-2.73367-9.89945.0-.39052.39052-1.02369.39052-1.41421.0-.39053-.39053-.39053-1.02369.0-1.41422 3.51472-3.51472 9.21316-3.51472 12.72796.0C18.7545 6.02646 18.7545 6.65962 18.364 7.05015c-.390599999999999.39052-1.0237.39052-1.4143.0z"
//                       ></path>
//                     </svg>
//                     <span>Loading...</span>
//                   </button>
//                 ) : (
//                   <button
//                     type="submit"
//                     style={{ boxShadow: "none" }}
//                     className="w-full inline-flex  text-[#fff]  px-2 py-5   bg-linear-gradient cursor-pointer select-none appearance-none items-center justify-center space-x-2 rounded-lg border border-blue-700 bg-blue-700 text-sm font-medium text-white transition"
//                   >
//                     Create an account
//                   </button>
//                 )}

//                 <p className="text-sm font-light text-gray-500 dark:text-gray-400">
//                   Already have an account?{" "}
//                   <Link
//                     to="/login"
//                     className="font-medium text-primary underline dark:text-primary-500"
//                   >
//                     Login here
//                   </Link>
//                 </p>
//               </form>
//             </div>
//           </div>
//         </div>
//       </section>
//       <ScrollToTop/>
//       <Footer />
//     </Fragment>
//   );
// };

// export default SignUp;
import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form, Input, Button } from "antd";
import Header from "../../Shear/Header/Header";
import Footer from "../../Shear/Footer/Footer";
import Head from "../../../layout/Head";
import ScrollToTop from "../../Shear/ScrollToTop";
import {
  useCreateUserWithEmailAndPassword,
  useUpdateProfile,
} from "react-firebase-hooks/auth";
import auth from "../../../FirebaseInit/FirebaseInit";
import useToken from "../../../Hooks/useToken";
import { toast } from "react-toastify";
import {
  UserOutlined,
  MailOutlined,
  LockOutlined,
  PhoneOutlined,
} from "@ant-design/icons";

const SignUp = () => {
  // start
  let navigate = useNavigate();
  /** Create User With email password start here **/
  const [createUserWithEmailAndPassword, user, loading, error] =
    useCreateUserWithEmailAndPassword(auth, { sendEmailVerification: true });

  /**  User profile update start here **/
  const [updateProfile, updateError] = useUpdateProfile(auth);
  const [token] = useToken(user);
  useEffect(() => {
    if (token) {
      navigate("/");
    }
  }, [token, user, navigate]);

  /** Sign Up error code start **/
  let errorMessage = "";
  if (error || updateError) {
    errorMessage = error?.message || updateError?.message;
    toast.error(errorMessage);
  }

  const onFinish = async (values) => {
    if (values.password === values.confirmPassword) {
      try {
        await createUserWithEmailAndPassword(values.email, values.password);
        await updateProfile({ displayName: values.name });
        toast("Successfully signed up!");
      } catch (error) {
        toast.error("Sorry, an error occurred");
      }
    } else {
      toast.error("Sorry, your passwords do not match");
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Fragment>
      <Head
        Title="Sign Up"
        href="/register"
        description="IT Services Providers are companies that offer a range of IT services and solutions to help organizations manage their technology infrastructure | Register Pages"
      />
      <Header title="Sign Up" />
      <section className="bg-gray-50 dark:bg-gray-900 py-10">
        <div className="flex flex-col items-center justify-center px-6 mx-auto  py-20">
          <div className="w-full bg-white rounded-lg shadow dark:border max-md:mt-0 max-sm:max-w-md max-xl:p-0 border border-[#f7f7f7]">
            <div className="p-6 space-y-4 max-md:space-y-6 max-sm:p-8">
              <h2 className="text-xl text-linear-gradient font-bold leading-tight tracking-tight text-gray-900 max-md:text-2xl dark:text-white">
                Sign Up
              </h2>

              <Form
                name="basic"
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                className="space-y-4 max-md:space-y-6"
              >
                <Form.Item
                  name="name"
                  rules={[
                    { required: true, message: "Please input your name!" },
                  ]}
                >
                  <Input
                    placeholder="Enter Your Name"
                    prefix={
                      <UserOutlined style={{ color: "rgba(0,0,0,.25)" }} />
                    }
                  />
                </Form.Item>

                <Form.Item
                  name="email"
                  rules={[
                    {
                      required: true,
                      type: "email",
                      message: "Please input your email!",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Your Email"
                    prefix={
                      <MailOutlined style={{ color: "rgba(0,0,0,.25)" }} />
                    }
                  />
                </Form.Item>

                <Form.Item
                  name="password"
                  rules={[
                    { required: true, message: "Please input your password!" },
                  ]}
                >
                  <Input.Password
                    placeholder="Enter Your Password"
                    prefix={
                      <LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />
                    }
                  />
                </Form.Item>

                <Form.Item
                  name="confirmPassword"
                  rules={[
                    {
                      required: true,
                      message: "Please confirm your password!",
                    },
                  ]}
                >
                  <Input.Password
                    placeholder="Enter Your Confirm Password"
                    prefix={
                      <LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />
                    }
                  />
                </Form.Item>

                <Form.Item>
                  {loading ? (
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading
                      className="bg-primary"
                    >
                      Loading...
                    </Button>
                  ) : (
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="w-full bg-primary h-10 text-center"
                    >
                      Create an account
                    </Button>
                  )}
                </Form.Item>
              </Form>
              <p className="text-sm font-light text-gray-500 dark:text-gray-400">
                Already have an account?{" "}
                <Link
                  to="/login"
                  className="font-medium text-primary underline dark:text-primary-500"
                >
                  Login here
                </Link>
              </p>
            </div>
          </div>
        </div>
      </section>
      <ScrollToTop />
      <Footer />
    </Fragment>
  );
};

export default SignUp;
